import React from 'react';
import { MenuIcon, XIcon, GlobeIcon } from './Icons';

const NavBar = ({ language, setLanguage, mobileMenuOpen, setMobileMenuOpen }) => {
  const handleNavClick = () => {
    setMobileMenuOpen(false);
  };

  // Navigation translations
  const translations = {
    en: {
      home: 'Home',
      accommodations: 'Where to Stay',
      itinerary: 'Itinerary',
      tips: 'Travel Tips',
      contact: 'Contact'
    },
    fr: {
      home: 'Accueil',
      accommodations: 'Hébergement',
      itinerary: 'Programme',
      tips: 'Conseils de Voyage',
      contact: 'Contact'
    }
  };

  const t = translations[language];

  return (
    <nav className="nav-fixed">
      <div className="nav-container">
        <div className="nav-content">
          <div className="nav-logo">F & T</div>
          
          <div className="nav-links">
            <a href="#home" className="nav-link">{t.home}</a>
            <a href="#accommodations" className="nav-link">{t.accommodations}</a>
            <a href="#itinerary" className="nav-link">{t.itinerary}</a>
            <a href="#tips" className="nav-link">{t.tips}</a>
            <a href="#contact" className="nav-link">{t.contact}</a>
          </div>

          <div className="nav-lang">
            <GlobeIcon />
            <select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              className="lang-select"
            >
              <option value="en">English</option>
              <option value="fr">Français</option>
            </select>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="nav-mobile-btn"
          >
            {mobileMenuOpen ? <XIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="mobile-menu">
          <a href="#home" className="mobile-menu-item" onClick={handleNavClick}>{t.home}</a>
          <a href="#accommodations" className="mobile-menu-item" onClick={handleNavClick}>{t.accommodations}</a>
          <a href="#itinerary" className="mobile-menu-item" onClick={handleNavClick}>{t.itinerary}</a>
          <a href="#tips" className="mobile-menu-item" onClick={handleNavClick}>{t.tips}</a>
          <a href="#contact" className="mobile-menu-item" onClick={handleNavClick}>{t.contact}</a>
          
          <div className="mobile-lang">
            <GlobeIcon />
            <select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              className="lang-select"
            >
              <option value="en">English</option>
              <option value="fr">Français</option>
            </select>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavBar;